export default __webpack_public_path__ + "static/media/pfohl_playeronly.95ef55cf.png";